import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';
import QuickSearch from './QuickSearchBase';

export default withCombinedRouteParams(QuickSearch);
